import { render, staticRenderFns } from "./fileStatusPop.vue?vue&type=template&id=fdc50e6c&scoped=true"
import script from "./fileStatusPop.vue?vue&type=script&lang=js"
export * from "./fileStatusPop.vue?vue&type=script&lang=js"
import style0 from "./fileStatusPop.vue?vue&type=style&index=0&id=fdc50e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc50e6c",
  null
  
)

export default component.exports